import axios from 'axios'
import constants from '../../../constants'

export const getCustomerTraining = async (customerNumber: string) => {
  const { data } = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/customer-trainings/metadata?scope=dashboardTraining`)
  return data
}
